import { ElMessage } from 'element-plus';
import request from '../../api/request';
import router from '../../router';
import emitter from '../../utils/eventBus';
class chatFlow {
    // 创建聊天
    createChat(model, keyword, viewType, callBack = () => { }, typeTitle = '', isJump = true) {
        return new Promise(async (resolve, reject) => {
            request
                .post('/app-api/lt/ai/chat/conversation/create-my', {
                model: model,
                // title: `${typeTitle || '新对话'} | ${keyword.slice(0, 50)}`
                title: keyword.slice(0, 50)
            })
                .then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    callBack();
                    resolve(res);
                    if (isJump) {
                        router.push(`/chat?chatid=${res.data}&viewType=${viewType}`);
                    }
                }
                else if ((res === null || res === void 0 ? void 0 : res.code) != 401) {
                    // reject(res)
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            })
                .catch(err => {
                // reject(err)
            });
        });
    }
    // 更新聊天
    updateChat(chatid, modelId, title = '', systemMessage = '') {
        return new Promise((resolve, reject) => {
            // 更新会话
            request
                .put('/app-api/lt/ai/chat/conversation/update-my', {
                id: chatid,
                title: title || null,
                modelId: modelId,
                temperature: 1,
                maxTokens: 4096,
                maxContexts: 20,
                systemMessage: systemMessage || null
            })
                .then((updateRes) => {
                if ((updateRes === null || updateRes === void 0 ? void 0 : updateRes.code) == 0) {
                    resolve(updateRes);
                }
                else {
                    reject(updateRes);
                    ElMessage.warning(updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg);
                }
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    // 获取聊天详情
    detailsChat(chatid) {
        return new Promise((resolve, reject) => {
            request
                .get('/app-api/lt/ai/chat/conversation/get-my', {
                id: chatid
            })
                .then((res) => {
                var _a;
                if (!(res === null || res === void 0 ? void 0 : res.data))
                    return;
                request
                    .get('/app-api/lt/ai/chat/message/list-by-conversation-id', {
                    conversationId: (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.id
                })
                    .then((uRes) => {
                    if ((uRes === null || uRes === void 0 ? void 0 : uRes.code) == 0) {
                        resolve(uRes.data);
                    }
                    else {
                        reject(uRes);
                    }
                })
                    .catch(err => {
                    reject(err);
                });
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    /**
     * ai绘画
     */
    // 生成图片
    generateImages(query, callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request
                .post('/app-api/lt/ai/image/volc/imagine', query)
                .then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    callBack();
                    resolve(res);
                    return;
                }
                else if ((res === null || res === void 0 ? void 0 : res.code) != 401) {
                    // ElMessage.warning(res?.msg)
                }
                reject(res);
            })
                .catch(err => { });
        });
    }
    // 查询生成图片
    queryGenerateImages(query, callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request
                .post('/app-api/lt/ai/image/volc/query', query)
                .then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    callBack();
                    resolve(res === null || res === void 0 ? void 0 : res.data);
                }
                else if ((res === null || res === void 0 ? void 0 : res.code) != 401) {
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            })
                .catch(err => { });
        });
    }
    // 更新所有生成图片状态
    queryAndUpdateAll(query = {}, callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request
                .get('/app-api/lt/ai/image/volc/queryAndUpdateAll', query)
                .then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    callBack();
                    resolve(res === null || res === void 0 ? void 0 : res.data);
                }
                else if ((res === null || res === void 0 ? void 0 : res.code) != 401) {
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            })
                .catch(err => { });
        });
    }
    // 创建对话
    createDrawChat(name, viewType = 'drawing', callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request
                .post('/app-api/lt/ai/image/createImageSession', {
                name
            })
                .then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    callBack();
                    resolve(res);
                    router.push(`/drawing_chat?chatid=${res.data}&viewType=${viewType}`);
                }
                else if ((res === null || res === void 0 ? void 0 : res.code) != 401) {
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            })
                .catch(err => { });
        });
    }
    // 更新绘画
    updateDrawChat(id, name) {
        return new Promise((resolve, reject) => {
            // 更新会话
            request
                .post('/app-api/lt/ai/image/updateSession', {
                id,
                name
            })
                .then((updateRes) => {
                if ((updateRes === null || updateRes === void 0 ? void 0 : updateRes.code) == 0) {
                    resolve(updateRes);
                }
                else {
                    reject(updateRes);
                    ElMessage.warning(updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg);
                }
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    // 获取绘画详情
    detailsDrawChat(id, publicStatus) {
        return new Promise((resolve, reject) => {
            request
                .get('/app-api/lt/ai/image/getSessionDetailById', {
                id
            })
                .then((uRes) => {
                if ((uRes === null || uRes === void 0 ? void 0 : uRes.code) == 0) {
                    resolve(uRes.data);
                }
                else {
                    reject(uRes);
                    ElMessage.warning(uRes === null || uRes === void 0 ? void 0 : uRes.msg);
                }
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    // 获取绘画详情
    getMyDrawChat(id, publicStatus) {
        return new Promise((resolve, reject) => {
            request
                .get('/app-api/lt/ai/image/get-my', {
                id
            })
                .then((uRes) => {
                if ((uRes === null || uRes === void 0 ? void 0 : uRes.code) == 0) {
                    resolve(uRes.data);
                }
                else {
                    reject(uRes);
                    ElMessage.warning(uRes === null || uRes === void 0 ? void 0 : uRes.msg);
                }
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    /**
     * 音乐生成
     */
    // 创建音乐对话
    createMusicChat(name, viewType, callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request
                .post('/app-api/lt/ai/volc/music/createSession', {
                name
            })
                .then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    callBack();
                    resolve(res);
                }
                else {
                    reject(res);
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            })
                .catch(err => { });
        });
    }
    // 获取我的音乐
    getMyMusic(query = {}, callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request.get('/app-api/lt/ai/volc/music/get-my', query).then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    callBack();
                    resolve(res === null || res === void 0 ? void 0 : res.data);
                }
                else {
                    reject(res);
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            });
        });
    }
    // 更新音乐
    querySongs(callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request.get('/app-api/lt/ai/volc/music/querySongs', {}).then((res) => {
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    resolve(res);
                    callBack();
                }
                else {
                    reject(res);
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            });
        });
    }
    // 获取歌曲
    genSong(query = {}, callBack = () => { }) {
        return new Promise(async (resolve, reject) => {
            request.post('/app-api/lt/ai/volc/music/genSong', query).then((res) => {
                var _a;
                if ((res === null || res === void 0 ? void 0 : res.code) == 0) {
                    resolve(res === null || res === void 0 ? void 0 : res.data);
                    emitter.emit('playMusic', {
                        sessionId: (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.id
                    });
                    callBack();
                }
                else {
                    reject(res);
                    ElMessage.warning(res === null || res === void 0 ? void 0 : res.msg);
                }
            });
        });
    }
    // 更新音乐
    updateMusicChat(id, name) {
        return new Promise((resolve, reject) => {
            // 更新会话
            request
                .post('/app-api/lt/ai/volc/music/updateSession', {
                id,
                name
            })
                .then((updateRes) => {
                if ((updateRes === null || updateRes === void 0 ? void 0 : updateRes.code) == 0) {
                    resolve(updateRes);
                }
                else {
                    reject(updateRes);
                    ElMessage.warning(updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg);
                }
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    // 获取音乐详情
    getSessionDetail(id) {
        return new Promise((resolve, reject) => {
            request
                .get('/app-api/lt/ai/volc/music/getSessionDetail', {
                id
            })
                .then((updateRes) => {
                if ((updateRes === null || updateRes === void 0 ? void 0 : updateRes.code) == 0) {
                    resolve(updateRes === null || updateRes === void 0 ? void 0 : updateRes.data);
                }
                else {
                    reject(updateRes);
                    ElMessage.warning(updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg);
                }
            })
                .catch(err => {
                reject(err);
            });
        });
    }
}
const chat = new chatFlow();
export default chat;
